import { cn } from '../../lib/cn';
import type { InfrastructureRow } from '../../enterprisedevops/framework';

type Props = { resources?: InfrastructureRow[] };

export function InfrastructurePanel({ resources = [] }: Props) {
  return (
    <div className="space-y-2">
      {resources.map((r) => (
        <div key={r.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{r.name}</p>
            <p className="text-xs text-slate-500">{r.capability}</p>
          </div>
          <div className="text-right">
            {r.utilization !== '—' && <p className="text-xs text-slate-500">{r.utilization}</p>}
            <span className={cn(
              'text-xs font-medium',
              r.status === 'healthy' || r.status === 'synced' || r.status === 'active' || r.status === 'rotated'
                ? 'text-success-600' : 'text-slate-500',
            )}>
              {r.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
